// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/css/frontend/style"], function() { return __webpack_require__("./assets/bebidas-navidad-2023/frontend.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
